import React, { useCallback } from 'react';
import { COLORS, Icon } from '@livecommerce/design-system';
import { styled } from '@linaria/react';
import HeaderItem from './HeaderItem.jsx';
import useSalesforceChat from 'components-v3/SalesforceChat/useSalesforceChat.js';
import DragHandle from 'components-v3/SalesforceChat/DragHandle.jsx';
import { useLocalization } from 'contexts/LocalizationContext.jsx';

const HeaderItemContents = styled.div`
  display: flex;
  justify-content: left;
  position: relative;
`;

const SalesforceChatHeaderItem = () => {
  const {
    isReady,
    isOpen,
    open,
    close,
    handleMouseDown,
    position,
    iframeRect,
  } = useSalesforceChat();
  const { t } = useLocalization();

  const onClick = useCallback(() => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  }, [isOpen, open, close]);

  if (!isReady) {
    return null;
  }

  return (
    <>
      {isOpen && <DragHandle onMouseDown={handleMouseDown} position={position} iframeRect={iframeRect} />}
      <HeaderItem
        label={t('salesforceChat.buttonLabel')}
        active={isOpen}
        onClick={onClick}
        data-testid="salesforce-chat-header-item"
        id="salesforce-support-chat-button"
      >
        <HeaderItemContents>
          <Icon name="chat" color={COLORS.orange_500} />
        </HeaderItemContents>
      </HeaderItem>
    </>
  );
};

export default SalesforceChatHeaderItem;

